<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="page_vii"></a>You have navigated with raging soul far from the paternal home, passing beyond the seas’ double rocks and now you inhabit a foreign land.</p>
<p class="textcenter"><em>Medea</em><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06.vue?48f6ef07